import React from "react";
import { Link } from "react-router-dom";
import "../style.scss";

const isExternal = (url) => /^(https?:)?\/\//.test(url);

const BlurredLinkedString = ({ value, linkedTo, str }) => {
  return (
    <>
      {value?.state !== "LOADED" ? (
        <span className="blur">Ensuro</span>
      ) : isExternal(linkedTo) ? (
        <a href={linkedTo} target="_blank" rel="noopener noreferrer">
          <p>{str}</p>
        </a>
      ) : (
        <Link to={linkedTo}>
          <p>{str}</p>
        </Link>
      )}
    </>
  );
};

export default BlurredLinkedString;
